<Panel w="20" minw="20" p="md">

  {#each items as _this} 
 
    {#if _this}
      <Panel 
        on:click={() => dispatch("selected", { id: _this.id })}
        bg={selected === _this.id ? 'gray800' : null}
        color={selected === _this.id ? 'white' : 'body'}
        border-bottom="2px solid transparent"
        rounded='xs'
        px="nm" py="nm" mb="xs"
        pointer
        hover>
        { _this.title || '...'}
      </Panel>
    {/if}

  {/each}

</Panel> 

<script>
  import { createEventDispatcher } from 'svelte'
  import { Panel, Label } from 'svelte-stylo'

  export let
    items = [],
    selected = null;

  const dispatch = createEventDispatcher()
</script>

